import React, { useState, useEffect } from 'react';
import { Tabs, Tab } from '@mui/material';
import { CaretRight } from '@phosphor-icons/react';
import useProductCategory from '../../hooks/useProductCategory';

const TemplateCategoryNav = ({ colors = {}, isMobileView = false, websiteData = {} }) => {
    const [activeCategory, setActiveCategory] = useState(undefined);

    const { fetchProductCategoryByShop, data: productCategory } = useProductCategory();

    useEffect(() => {
        if (websiteData?.storeId) {
            fetchProductCategoryByShop(websiteData.storeId);
        }
    }, [websiteData?.storeId]);

    console.log('productCategory', productCategory);

    if (isMobileView) {
        return (
            <div className="container" style={{ marginBottom: '48px' }}>
                <div className="d-flex flex-column gap-10 mt-5">
                    <button
                        type="button"
                        onClick={() => setActiveCategory(undefined)}
                        className="d-flex align-items-center justify-content-between border-0 bg-transparent py-10 px-20"
                        style={{ textAlign: 'left', color: activeCategory === undefined ? colors.categoryActive || '#2563EB' : '#000000' }}
                    >
                        <span className="fw-medium" style={{ fontSize: '14px' }}>
                            All Products
                        </span>
                        <CaretRight size={16} />
                    </button>
                    {Array.isArray(productCategory) &&
                        productCategory.map((cat) => (
                            <button
                                key={cat.id}
                                type="button"
                                onClick={() => setActiveCategory(cat.id)}
                                className="d-flex align-items-center justify-content-between border-0 bg-transparent py-10 px-20"
                                style={{
                                    textAlign: 'left',
                                    color: activeCategory === cat.id ? colors.categoryActive || '#2563EB' : '#000000'
                                }}
                            >
                                <span className="fw-medium" style={{ fontSize: '14px' }}>
                                    {cat.name}
                                </span>
                                <CaretRight size={16} />
                            </button>
                        ))}
                </div>
            </div>
        );
    }

    return (
        <div className="container" style={{ marginBottom: '48px' }}>
            <Tabs
                value={activeCategory === undefined ? 'all-products' : activeCategory}
                onChange={(event, newValue) => setActiveCategory(newValue === 'all-products' ? undefined : newValue)}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                    borderBottom: 1,
                    borderColor: '#f0f0f0',
                    '& .MuiTabs-indicator': {
                        backgroundColor: colors.navActive || '#2563EB',
                        height: '2px'
                    },
                    '& .MuiTab-root': {
                        textTransform: 'none',
                        fontWeight: 500,
                        fontSize: '14px',
                        color: '#999999',
                        minWidth: 'auto',
                        padding: '12px 24px',
                        marginRight: '32px'
                    },
                    '& .Mui-selected': {
                        color: `${colors.navActive || '#2563EB'} !important`,
                        fontWeight: 600
                    }
                }}
            >
                <Tab label="All Products" value="all-products" />
                {Array.isArray(productCategory) && productCategory.map((cat) => <Tab key={cat.id} label={cat.name} value={cat.id} />)}
            </Tabs>
        </div>
    );
};

export default TemplateCategoryNav;
